import { render, staticRenderFns } from "./ChannelListItem.vue?vue&type=template&id=dce68276&"
import script from "./ChannelListItem.vue?vue&type=script&lang=js&"
export * from "./ChannelListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports